import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { FormData, recipientOptions } from "../types";

interface RecipientStepProps {
  formData: FormData;
  onChange: (field: keyof FormData, value: string) => void;
}

const RecipientStep = ({ formData, onChange }: RecipientStepProps) => {
  return (
    <motion.div
      key="recipient"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-6"
    >
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <Heart className="w-8 h-8 text-primary" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground mb-2">
          Who Is the Song For?
        </h2>
        <p className="text-muted-foreground">
          Tell us about the person or people receiving this song.
        </p>
      </div>

      <div className="space-y-4">
        <Label>Select one *</Label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {recipientOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange("recipient", option.value)}
              className={`p-4 rounded-xl border-2 transition-all text-center ${
                formData.recipient === option.value
                  ? "border-primary bg-primary/5"
                  : "border-border hover:border-primary/50"
              }`}
            >
              <span className="text-sm font-medium">{option.label}</span>
            </button>
          ))}
        </div>
      </div>

      {formData.recipient === "other" && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="space-y-2"
        >
          <Label htmlFor="recipientOther">Describe the relationship *</Label>
          <Input
            id="recipientOther"
            placeholder="Example: godchild, mentor, cousin"
            value={formData.recipientOther}
            onChange={(e) => onChange("recipientOther", e.target.value)}
          />
        </motion.div>
      )}
    </motion.div>
  );
};

export default RecipientStep;
